import type {ReviewSummary} from '../../../../page-data/payloads/review-summaries'
import {CompactComment} from '../shared/CompactComment'
import {CompactContainer} from '../shared/CompactContainer'

export function ReviewDescription({reviewSummary}: {reviewSummary: ReviewSummary}) {
  const comment = reviewSummary

  if (comment.body.trim().length === 0) {
    return null
  }

  return (
    <CompactContainer>
      <CompactComment
        body={comment.body}
        isPending={false}
        author={{login: comment.authorLogin, avatarUrl: comment.authorAvatarUrl}}
      />
    </CompactContainer>
  )
}
